module.exports = __webpack_public_path__ + "static/media/头像.5e5b6b62.png";